<script setup>
import { useTriviaStore } from '@/stores/trivia.js';
const store = useTriviaStore();
const game = store.CurrentGame;

function answerData(question) {
  let answerData = `${question.category} (${question.points} points) `;
  if (question.answerData) {
    if (question.answerData.text) {
      answerData += `<br /><strong>${question.answerData.text}</strong>`;
    }
    // Loop through each segment
    for (let i = 0; i < question.segments.length; i += 1) {
      const segment = question.segments[i];
      if (segment.type === 'clueAnswer') {
        for (let j = 0; j < segment.data.length; j += 1) {
          const clue = segment.data[j];
          if (clue.highlightOnAnswer) {
            answerData += `<br /><strong>${clue.clue}</strong>`;
          } else if (clue.answer) {
            answerData += clue.indexLabel ? `<br />${clue.indexLabel}: ` : `<br />${j + 1}: `;
            answerData += `<strong>${clue.clue}</strong> ${clue.answer} `;
          }
        }
      }
      if (segment.type === 'blankFill') {
        for (let j = 0; j < segment.data.length; j += 1) {
          answerData += `<br /><strong>${segment.data[j]}</strong>`;
        }
      }
    }
  }
  return answerData;
}

</script>

<template>
  <div
      class="answer-sheet">
    <div v-for="(round, index) in game.rounds" :key="round._id">
      <h2
          style="color: white; background-color: black; ">Round {{Number(index) + 1}}</h2>
      <div
          v-for="(question, index) in round"
          style="border: 2px solid black; padding: 10px;">
        <div v-html="`Q${index + 1}: ${answerData(question)}`"
        />
      </div>
    </div>
  </div>
</template>


<style scoped>
  strong {
    color: black !important;
  }
  .answer-sheet {
    color: black;
    background-color: white;
    padding: 2vh 5vw;
    text-align: center;
  }
/* Add your custom styles here */
</style>